@let page = this.currentPage();

@if (page) {
  @switch (page.view.type) {
    @case ('builder.v1') {
      <app-page-builder [pageId]="page.id" [pageViewConfig]="page.view"/>
    }
    @case ('service-centre.v1') {
      <app-page-service-centre
        [pageName]="page.name"
        [pageViewConfig]="page.view"
      />
    }
    @case ('pdf-menu.v1') {
      <app-page-pdf-menu
        [pageId]="page.id"
        [pageName]="page.name"
        [pageViewConfig]="page.view"
      />
    }
    @case ('specials.v1') {
      <app-page-specials
        [pageName]="page.name"
        [pageViewConfig]="page.view"
      />
    }
    @case ('more.v1') {
      <app-page-more
        [pageId]="page.id"
        [pageName]="page.name"
        [pageViewConfig]="page.view"
      />
    }
  }
} @else {
  <p class="unavailable" role="status">This page is unavailable.</p>
}
